import styled from 'styled-components';
import { ShadowIconButton } from 'components/common/material-ui/custom-components';
import { colorUsage } from 'stylesheet';
import { Arrow } from 'theme/icons';
var StyledShadowIconButton = styled(ShadowIconButton).withConfig({
  displayName: "BackButtonstyle__StyledShadowIconButton",
  componentId: "sc-7m75u3-0"
})(["&:hover path{fill:", ";}"], colorUsage.iconGradientHoverForeground);
var StyledArrow = styled(Arrow).withConfig({
  displayName: "BackButtonstyle__StyledArrow",
  componentId: "sc-7m75u3-1"
})(["& path{fill:", ";}"], colorUsage.iconForeground);
export { StyledShadowIconButton, StyledArrow };